"use strict";

var _inherits = require("/home/vadim/oskar4/oskar/work/ArangoDB/js/apps/system/_admin/aardvark/APP/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/home/vadim/oskar4/oskar/work/ArangoDB/js/apps/system/_admin/aardvark/APP/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/vadim/oskar4/oskar/work/ArangoDB/js/apps/system/_admin/aardvark/APP/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _regeneratorRuntime = require("/home/vadim/oskar4/oskar/work/ArangoDB/js/apps/system/_admin/aardvark/APP/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/home/vadim/oskar4/oskar/work/ArangoDB/js/apps/system/_admin/aardvark/APP/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/vadim/oskar4/oskar/work/ArangoDB/js/apps/system/_admin/aardvark/APP/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var error_1 = require("./error");

var ViewType;

(function (ViewType) {
  ViewType["ARANGOSEARCH_VIEW"] = "arangosearch";
})(ViewType = exports.ViewType || (exports.ViewType = {}));

var VIEW_NOT_FOUND = 1203;

var BaseView = /*#__PURE__*/function () {
  function BaseView(connection, name) {
    _classCallCheck(this, BaseView);

    this.isArangoView = true;
    this.name = name;
    this._connection = connection;
  }

  _createClass(BaseView, [{
    key: "get",
    value: function get() {
      return this._connection.request({
        path: "/_api/view/".concat(this.name)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "exists",
    value: function exists() {
      return this.get().then(function () {
        return true;
      }, function (err) {
        if (error_1.isArangoError(err) && err.errorNum === VIEW_NOT_FOUND) {
          return false;
        }

        throw err;
      });
    }
  }, {
    key: "rename",
    value: function rename(name) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var result;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._connection.request({
                  method: "PUT",
                  path: "/_api/view/".concat(this.name, "/rename"),
                  body: {
                    name: name
                  }
                }, function (res) {
                  return res.body;
                });

              case 2:
                result = _context.sent;
                this.name = name;
                return _context.abrupt("return", result);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "drop",
    value: function drop() {
      return this._connection.request({
        method: "DELETE",
        path: "/_api/view/".concat(this.name)
      }, function (res) {
        return res.body;
      });
    }
  }]);

  return BaseView;
}();

exports.BaseView = BaseView;

var ArangoSearchView = /*#__PURE__*/function (_BaseView) {
  _inherits(ArangoSearchView, _BaseView);

  var _super = _createSuper(ArangoSearchView);

  function ArangoSearchView() {
    var _this;

    _classCallCheck(this, ArangoSearchView);

    _this = _super.apply(this, arguments);
    _this.type = ViewType.ARANGOSEARCH_VIEW;
    return _this;
  }

  _createClass(ArangoSearchView, [{
    key: "create",
    value: function create() {
      var properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return this._connection.request({
        method: "POST",
        path: "/_api/view",
        body: Object.assign({}, properties, {
          name: this.name,
          type: this.type
        })
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "properties",
    value: function properties() {
      return this._connection.request({
        path: "/_api/view/".concat(this.name, "/properties")
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "setProperties",
    value: function setProperties() {
      var properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return this._connection.request({
        method: "PATCH",
        path: "/_api/view/".concat(this.name, "/properties"),
        body: properties
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "replaceProperties",
    value: function replaceProperties() {
      var properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return this._connection.request({
        method: "PUT",
        path: "/_api/view/".concat(this.name, "/properties"),
        body: properties
      }, function (res) {
        return res.body;
      });
    }
  }]);

  return ArangoSearchView;
}(BaseView);

exports.ArangoSearchView = ArangoSearchView;

function constructView(connection, data) {
  if (data.type && data.type !== ViewType.ARANGOSEARCH_VIEW) {
    throw new Error("Unknown view type \"".concat(data.type, "\""));
  }

  return new ArangoSearchView(connection, data.name);
}

exports.constructView = constructView;